export default "__VITE_ASSET__BxYbsV7j__"